import { AbstractUploadService, IFile } from '@aionzdev/modules';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { catchError, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UploadService extends AbstractUploadService {
  private readonly urlNodeApi = `${environment.apiUrl}/upload`;
  private readonly _http = inject(HttpClient);
  constructor() {
    super();
  }

  array(path: string, files: File[]): Observable<IFile[]> {
    const formData = new FormData();

    formData.append('path', path);
    files.forEach((file) => formData.append('files', file));

    return this._http.post<IFile[]>(`${this.urlNodeApi}/array`, formData).pipe(
      take(1),
      catchError((error) => throwError(() => error)),
    );
  }

  single(path: string, file: File): Observable<IFile> {
    const formData = new FormData();

    formData.append('path', path);
    formData.append('file', file);

    return this._http.post<IFile>(`${this.urlNodeApi}/single`, formData).pipe(
      take(1),
      catchError((error) => throwError(() => error)),
    );
  }
}
